module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fCxc4EsA.16423fb4.woff2";